import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/file-word': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M369.9 97.9L286 14C277 5 264.8-0.1 252.1-0.1H48C21.5 0 0 21.5 0 48V464C0 490.5 21.5 512 48 512H336C362.5 512 384 490.5 384 464V131.9C384 119.2 378.9 106.9 369.9 97.9zM332.1 128H256V51.9L332.1 128zM48 464V48H208V152C208 165.3 218.7 176 232 176H336V464H48zM268.1 256C262.4 256 257.5 260 256.4 265.5 235.8 363.2 236 360.9 235.4 369 235.2 367.8 235 366.4 234.7 364.7 233.9 359.6 235 364.9 211.1 265.2 209.8 259.8 205 256 199.4 256H186.1C180.6 256 175.8 259.8 174.4 265.1 150 364.1 150.4 361.3 149.6 368.8 149.5 367.7 149.4 366.3 149.1 364.6 148.4 359.4 135 291.3 130 265.6 128.9 260 124 255.9 118.2 255.9H101.4C93.6 255.9 87.9 263.2 89.7 270.7 97.7 303.3 116.4 380.2 122.9 406.7 124.2 412.1 129 415.8 134.6 415.8H159.8C165.3 415.8 170.1 412.1 171.4 406.7L189.3 335.3C190.8 329.1 191.8 323.3 192.3 318L195.2 335.3C195.3 335.7 207.8 385.8 213.1 406.7 214.4 412 219.2 415.8 224.7 415.8H249.4C254.9 415.8 259.7 412.1 261 406.7 281.8 324.8 291.2 287.7 295.5 270.7 297.4 263.1 291.7 255.8 283.9 255.8H268.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/file-word.js
// module id = Az3p
// module chunks = 144